import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';
import { Category } from '../services/api';
import { useTranslations } from '../translations';
import { createPageUrl } from '../utils/appRoutes';
import './CategoryTooltip.css';

interface CategoryTooltipProps {
  category: Category;
  onViewAll: (categoryId: string) => void;
  onSubcategoryClick: (subcategoryId: string, categoryId: string) => void;
}

const CategoryTooltip: React.FC<CategoryTooltipProps> = ({ category, onViewAll, onSubcategoryClick }) => {
  const t = useTranslations();

  return (
    <div
      className="category-tooltip-expanded"
      role="region"
      aria-label={`${t.home.subcategoriesLabel}: ${category.name}`}
    >
      <div className="category-tooltip-header">
        <div className="category-tooltip-identity">
          <span className="category-tooltip-icon" aria-hidden>
            <img src={category.iconHighlightedUrl || category.iconUrl} alt="" />
          </span>
          <div className="category-tooltip-heading">
            <span className="category-tooltip-label">{t.home.subcategoriesLabel}</span>
            <h3>{category.name}</h3>
          </div>
        </div>

        <a
          href={createPageUrl('category', { id: category.id, name: category.name })}
          className="category-view-all-link"
          onClick={(event) => {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
              return;
            }
            event.preventDefault();
            onViewAll(category.id);
          }}
        >
          <span>{t.home.viewAllCategory}</span>
          <ArrowRight size={17} aria-hidden />
        </a>
      </div>

      <div className="subcategory-grid">
        {category.subCategories.map((subCategory) => (
          <button
            key={subCategory.id}
            type="button"
            className="btn-subcategory"
            onClick={() => onSubcategoryClick(subCategory.id, category.id)}
          >
            <span>{subCategory.name}</span>
            <ChevronRight size={16} aria-hidden />
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryTooltip;
